import { render, staticRenderFns } from "./arqueos.vue?vue&type=template&id=2b723cca&"
import script from "./arqueos.vue?vue&type=script&lang=js&"
export * from "./arqueos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports